export default class SwatchHelper {
    constructor(productBlocksSelector) {
        this.productBlocksSelector =
            typeof productBlocksSelector === "string"
                ? document.querySelectorAll(productBlocksSelector)
                : productBlocksSelector;
    }

    onSwatchRendered(callback) {
        let observer = new MutationObserver((mutations) => {
            for (let mutation of mutations) {
                for (let node of mutation.addedNodes) {
                    if (node.classList?.contains("swatch-single")) {
                        const searchedNode = node.querySelector("ul.swatch-view");
                        if (searchedNode) {
                            callback(node, searchedNode);
                        }
                    }
                }
            }
        });

        this.productBlocksSelector.forEach(function (productBlock) {
            observer.observe(productBlock, { childList: true, subtree: true });
        });
    }
}
